unit CardPaymentPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PaymentPage,
  Data.DB,
  WEBLib.DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Controls,
  WEBLib.DBCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Grids,
  WEBLib.WebCtrls, CustomerPage;

type
  TCardPaymentForm = class(TPaymentForm)
    procedure PaybyAltLabelClick(Sender: TObject);
  private
    [async]
    procedure PayByCard; async;
    { Private declarations }
  protected
    [async]
    procedure PayNow; async; override;
  public
    { Public declarations }
    [async]
    Procedure InitForm; async; override;

  protected procedure LoadDFMValues; override; end;

var
  CardPaymentForm: TCardPaymentForm;

implementation

{$R *.dfm}

uses
  MainDataModule,
  Gadget.Web.Consts, Gadget.Enumerations;

{ TCreditCardForm }

procedure TCardPaymentForm.InitForm;
var lKey: string;
begin
  inherited;

  lKey := Await(MainData.StripePublicKey);
  {$IFDEF PAS2JS}
  asm
    initStripe(lKey);
  end;
  {$ENDIF}

end;

procedure TCardPaymentForm.PaybyAltLabelClick(Sender: TObject);
begin
  ChangeSitePage(TGadgetPage.gpDirectDebit);
end;

procedure TCardPaymentForm.PayByCard;
  procedure StripeTokenCallback(result: string);
  begin
    if result.StartsWith('Error') then
    begin
      ShowMessage('Token creation failed: ' + result);
      Exit;
    end;

    MainData.StripeSubscription(result,
      procedure(Success: boolean; ErrorMessage: string)
      begin
        if Success then
        begin
          MainData.AfterPaymentProcessed := AfterPaymentProcessed;
          MainData.UpdateBasketWithPayment(TPaymentProvider.Stripe);
        end
        else
        begin
          if ErrorMessage <> '' then
            ShowMessage('There was an error with your subscription. ' + ErrorMessage)
        end;
      end
  );
  end;

//var lKey: String;
begin

//  lKey := Await(MainData.StripePublicKey);
  {$IFDEF PAS2JS}
  asm
    var callback = function(result) {
      StripeTokenCallback(result);
    };
    GetToken(callback);
    //GetToken(callback, lKey);
  end;
  {$ENDIF}
end;

procedure TCardPaymentForm.PayNow;
begin
  inherited;
  PayByCard;
end;

procedure TCardPaymentForm.LoadDFMValues;
begin
  inherited LoadDFMValues;


  PaybyAltLabel.BeforeLoadDFMValues;
  MobileEdit.BeforeLoadDFMValues;
  EmailEdit.BeforeLoadDFMValues;
  LastNameEdit.BeforeLoadDFMValues;
  MarketingOKPanel.BeforeLoadDFMValues;
  MarketingOK.BeforeLoadDFMValues;
  PlaceOrderButton.BeforeLoadDFMValues;
  TermsOK.BeforeLoadDFMValues;
  try
    SetEvent(PaybyAltLabel, Self, 'OnClick', 'PaybyAltLabelClick');
    SetEvent(MobileEdit, Self, 'OnExit', 'nil');
    SetEvent(EmailEdit, Self, 'OnExit', 'nil');
    SetEvent(LastNameEdit, Self, 'OnExit', 'nil');
    MarketingOKPanel.Left := 311;
    MarketingOKPanel.Top := 477;
    MarketingOK.TabOrder := 10;
    PlaceOrderButton.TabOrder := 13;
    TermsOK.Left := 239;
    TermsOK.Top := 480;
    TermsOK.TabOrder := 11;
  finally
    PaybyAltLabel.AfterLoadDFMValues;
    MobileEdit.AfterLoadDFMValues;
    EmailEdit.AfterLoadDFMValues;
    LastNameEdit.AfterLoadDFMValues;
    MarketingOKPanel.AfterLoadDFMValues;
    MarketingOK.AfterLoadDFMValues;
    PlaceOrderButton.AfterLoadDFMValues;
    TermsOK.AfterLoadDFMValues;
  end;
end;

end.
